export const SET_LOCAL_SESSION = 'SET_LOCAL_SESSION';
export const UPDATE_AUTO_FILLED = 'UPDATE_AUTO_FILLED';
